module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("au8ZT"))).then(() => parcelRequire('d0iPb'));